import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPrivateOpp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "512pt",
	height: "512pt",
	padding: "5px",
	viewBox: "0 0 512 512",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "#474747",
		children: [/* @__PURE__ */ _jsx("path", { d: "m25.77 247.52v16.918c101.55 169.26 358.92 169.26 460.47 0v-16.918c-101.55-169.2-358.93-169.2-460.47 0zm230.23 118.33c-60.754 0-109.88-49.199-109.88-109.87 0-60.691 49.121-109.85 109.88-109.85 60.617 0 109.86 49.152 109.86 109.85 0.007812 60.676-49.242 109.87-109.86 109.87z" }), /* @__PURE__ */ _jsx("path", { d: "m256 205.23c-28.047 0-50.797 22.641-50.797 50.746 0 28.047 22.754 50.797 50.797 50.797 28.031 0 50.734-22.75 50.734-50.797 0-28.105-22.695-50.746-50.734-50.746z" })]
	})
});
export default SvgIconPrivateOpp;
